import { useState, useEffect } from 'react'
import SharedLink from './shared_links/shared_link'
import SharedLinkForm from './shared_links/shared_link_form'

const SharedLinks = ({ scope_type, scope_id }) => {
  const [links, setLinks] = useState([])
  const [objectSettings, setObjectSettings] = useState([])
  const [visibleCreateForm, setVisibleCreateForm] = useState(false)
  const isOwner = window.appData.user_owned_account_ids.split(',').includes(window.appData.account_id.toString())

  useEffect(() => {
    getLinks()
    getObjectSettings()
  }, [])

  useEffect(() => {
    window.clipboard(true)
  }, [links])

  const getObjectSettings = () => {
    jQuery.ajax({
      url: window.appData.api_path + '/shared_links/get_object_settings',
      data: {
        scope_type: scope_type,
        scope_id: scope_id
      },
      success: (data) => {
        setObjectSettings(data)
      }
    })
  }

  const getLinks = () => {
    jQuery.ajax({
      url: window.appData.api_path + '/shared_links',
      data: {
        scope_type: scope_type,
        scope_id: scope_id
      },
      success: (data) => {
        setLinks(data.shared_links)
      }
    })
  }

  const deleteLink = (link) => {
    dataConfirmModal.confirm({
      title: I18n.t('modal.title'),
      text: I18n.t('really-delete-shared-link'),
      zIindex: 10099,
      onCancel: () => {
        return false
      },
      onConfirm: () => {
        jQuery.ajax({
          url: window.appData.api_path + '/shared_links/' + link.id,
          method: 'DELETE',
          data: {
            scope_type: scope_type,
            scope_id: scope_id
          },
          success: () => {
            setLinks(links.filter((i) => i.id != link.id))
          }
        })
      }
    })
  }

  return (
    <div className="section">
      <a
        href={
          ['cs', 'sk'].includes(I18n.locale)
            ? 'https://www.caflou.cz/vzdelavaci-centrum/jak-sdilet-projekty-a-ukoly-externe'
            : 'https://www.caflou.com/education/how-to-share-projects-and-tasks-externally'
        }
        target="_blank"
      >
        {I18n.t('shared-links-help')}
        <i className="far fa-external-link ml-8"></i>
      </a>

      <div className="head pull-right mb-16">
        <div className="actions">
          <button
            className="btn btn-grey"
            onClick={() => {
              setVisibleCreateForm(!visibleCreateForm)
            }}
          >
            {I18n.t('shared-links-add-button')}
          </button>
        </div>
      </div>
      <div className="clearfix"></div>
      <div className="body">
        {visibleCreateForm && (
          <SharedLinkForm
            scope_type={scope_type}
            scope_id={scope_id}
            setVisibleCreateForm={setVisibleCreateForm}
            getLinks={getLinks}
            objectSettings={objectSettings}
            uuid="new"
          />
        )}

        {links && links.length ? (
          <div className="table_container mb-16">
            <table className="table contact">
              <colgroup>
                <col></col>
                {isOwner ? <col></col> : null}
                <col></col>
                <col></col>
                <col></col>
                <col style={{ width: '160px' }}></col>
              </colgroup>
              <thead>
                <tr>
                  <th>{I18n.t('activerecord.attributes.shared_link.name')}</th>
                  {isOwner ? <th>{I18n.t('activerecord.attributes.shared_link.user_id')}</th> : null}
                  <th>{I18n.t('activerecord.attributes.shared_link.tabs')}</th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <>
                  {links.map((link, index) => (
                    <SharedLink
                      link={link}
                      getLinks={getLinks}
                      deleteLink={() => {
                        deleteLink(link)
                      }}
                      key={index}
                      scope_type={scope_type}
                      scope_id={scope_id}
                      objectSettings={objectSettings}
                      isOwner={isOwner}
                    />
                  ))}
                </>
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default SharedLinks
